module.exports = __webpack_public_path__ + "static/media/review_default.3f314a0e.png";